import React, {useMemo, useContext} from 'react'
import PropTypes from 'prop-types'
import {createLevels} from 'hec/builder/models/learning-center'
import useLearningCenter from '~/app/hooks/use-learning-center'
import useFetchGoal from 'hec/hooks/learning-center/useFetchGoal'
import Level from './level'
import {BuilderContext} from '@builder.io/sdk-react'

export const LearningCenterLevels = ({attributes}) => {
    const builderContext = useContext(BuilderContext)
    const goalRef = builderContext.content.data.goal
    const {learningCenterData: sfccLearningCenterData, getGoalByID} = useLearningCenter()
    const {data: goalData, isLoading: isGoalDataLoading} = useFetchGoal(goalRef.id)
    const levelsModel = useMemo(() => {
        if (!goalData) return null
        return createLevels(goalData.data, getGoalByID(goalData.data?.id))
    }, [goalData, sfccLearningCenterData]) // eslint-disable-line react-hooks/exhaustive-deps

    if (isGoalDataLoading) return <div>Loading...</div>
    if (!levelsModel) return <div>Please select a goal</div>

    return (
        <div {...attributes}>
            <div className="bg-indigo-01-4">
                <div className="container py-10 lg:py-20 space-y-11 lg:space-y-16">
                    {levelsModel.map((level, levelIndex) => (
                        <Level
                            key={levelIndex}
                            levelData={level}
                            goalID={goalData.data?.id}
                            data-testid="learningCenterLevels"
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

LearningCenterLevels.propTypes = {
    goalRef: PropTypes.any,
    attributes: PropTypes.object
}

export const LearningCenterLevelsDefinition = {
    component: LearningCenterLevels,
    name: 'Learning Center Levels',
    noWrap: true
}
